var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          ref: "drawer",
          staticClass: "contacts-drawer Weforsys-common-drawer",
          attrs: {
            title: "内部聊天",
            visible: _vm.drawer,
            direction: "rtl",
            size: "280px",
            modal: true,
            wrapperClosable: false,
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c(
            "el-tabs",
            {
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _c("el-tab-pane", { attrs: { label: "消息", name: "reply" } }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value:
                          _vm.replyLoading && _vm.listQuery.currentPage == 1,
                        expression: "replyLoading && listQuery.currentPage==1",
                      },
                    ],
                    staticClass: "userList replyList",
                  },
                  [
                    _vm.replyList.length
                      ? _c(
                          "div",
                          _vm._l(_vm.replyList, function (item, i) {
                            return _c(
                              "div",
                              {
                                key: i,
                                staticClass: "userList-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.readInfo(item, true)
                                  },
                                },
                              },
                              [
                                _c("el-avatar", {
                                  attrs: {
                                    size: 36,
                                    src: _vm.define.comUrl + item.headIcon,
                                  },
                                }),
                                _c("div", { staticClass: "userList-txt" }, [
                                  _c(
                                    "p",
                                    { staticClass: "title" },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(item.realName) +
                                            "/" +
                                            _vm._s(item.account)
                                        ),
                                      ]),
                                      _c("el-badge", {
                                        attrs: {
                                          value: item.unreadMessage,
                                          hidden: !item.unreadMessage,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("p", { staticClass: "name" }, [
                                    _c("span", { staticClass: "content" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getMsgText(
                                            item.latestMessage,
                                            item.messageType
                                          )
                                        )
                                      ),
                                    ]),
                                    _c("span", { staticClass: "time" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("toDateText")(item.latestDate)
                                        )
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ],
                              1
                            )
                          }),
                          0
                        )
                      : _c("p", { staticClass: "noData-txt" }, [
                          _vm._v(_vm._s(_vm.$t("common.noData"))),
                        ]),
                  ]
                ),
              ]),
              _c(
                "el-tab-pane",
                { attrs: { label: "联系人", name: "contacts" } },
                [
                  _c(
                    "el-input",
                    {
                      staticClass: "search-input",
                      attrs: {
                        placeholder: "搜索：请输入关键词",
                        clearable: "",
                      },
                      model: {
                        value: _vm.listQuery.keyword,
                        callback: function ($$v) {
                          _vm.$set(_vm.listQuery, "keyword", $$v)
                        },
                        expression: "listQuery.keyword",
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "el-input__icon el-icon-search",
                        attrs: { slot: "suffix", title: "搜索" },
                        on: { click: _vm.search },
                        slot: "suffix",
                      }),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading && _vm.listQuery.currentPage == 1,
                          expression: "loading && listQuery.currentPage==1",
                        },
                      ],
                      ref: "userList",
                      staticClass: "userList",
                    },
                    [
                      _vm.userList.length
                        ? _c(
                            "div",
                            _vm._l(_vm.userList, function (item, i) {
                              return _c(
                                "div",
                                {
                                  key: i,
                                  staticClass: "userList-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.readInfo(item)
                                    },
                                  },
                                },
                                [
                                  _c("el-avatar", {
                                    attrs: {
                                      size: 36,
                                      src: _vm.define.comUrl + item.headIcon,
                                    },
                                  }),
                                  _c("div", { staticClass: "userList-txt" }, [
                                    _c("p", { staticClass: "title" }, [
                                      _vm._v(
                                        _vm._s(item.realName) +
                                          "/" +
                                          _vm._s(item.account)
                                      ),
                                    ]),
                                    _c("p", { staticClass: "name" }, [
                                      _c("span", [
                                        _vm._v(_vm._s(item.department)),
                                      ]),
                                    ]),
                                  ]),
                                ],
                                1
                              )
                            }),
                            0
                          )
                        : _c("p", { staticClass: "noData-txt" }, [
                            _vm._v(_vm._s(_vm.$t("common.noData"))),
                          ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("Im", { ref: "WeforsysIm", attrs: { "append-to-body": "" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }